import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth, AuthProvider } from './hooks/useAuth.jsx'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import ClienteForm from './pages/ClienteForm'
import LoadingSpinner from './components/LoadingSpinner'
import MainLayout from './layouts/MainLayout'
import GestionProgramacionesGPS from './pages/GestionProgramacionesGPS'
import GestionSimulacionesGPS from './pages/GestionSimulacionesGPS'
import GestionReplicasGPS from './pages/GestionReplicasGPS'
import SimulacionGPSForm from './pages/SimulacionGPSForm'
import SimularPosicionGPS from './pages/SimularPosicionGPS'
import GenerarRutaGPS from './pages/GenerarRutaGPS'
import ManualUsuario from './pages/ManualUsuario'
import GestionUsuarios from './pages/GestionUsuarios'
import UsuarioForm from './pages/UsuarioForm'
import UsuarioDetalle from './pages/UsuarioDetalle'
import GestionEmpresas from './pages/GestionEmpresas'

function AppContent() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Rutas públicas */}
        <Route 
          path="/login" 
          element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        {/* Rutas protegidas con layout */}
        <Route element={user ? <MainLayout /> : <Navigate to="/login" replace /> }>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/clientes/nuevo" element={<ClienteForm />} />
          <Route path="/clientes/editar/:id" element={<ClienteForm />} />
          <Route path="/programaciones-gps" element={<GestionProgramacionesGPS />} />
          <Route path="/simulaciones-gps" element={<GestionSimulacionesGPS />} />
          <Route path="/simulaciones-gps/replicas" element={<GestionReplicasGPS />} />
          <Route path="/simulaciones-gps/nueva" element={<SimulacionGPSForm />} />
          <Route path="/simulaciones-gps/editar/:id" element={<SimulacionGPSForm />} />
          <Route path="/simulaciones-gps/simular-posicion" element={<SimularPosicionGPS />} />
          <Route path="/simulaciones-gps/generar-ruta" element={<GenerarRutaGPS />} />
          <Route path="/manual-usuario" element={<ManualUsuario />} />
          <Route path="/usuarios" element={<GestionUsuarios />} />
          <Route path="/usuarios/nuevo" element={<UsuarioForm />} />
          <Route path="/usuarios/editar/:id" element={<UsuarioForm />} />
          <Route path="/usuarios/ver/:id" element={<UsuarioDetalle />} />
          <Route path="/empresas" element={<GestionEmpresas />} />
        </Route>
        {/* Ruta por defecto */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        {/* Ruta 404 */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App 